import { FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import { useSelector } from 'react-redux';

// components
import { PriceDisplay } from 'dibs-buyer-price';
import { FormattedMessage } from 'dibs-react-intl';
import { PdpSharedPurchaseButton } from '../PdpSharedButtons/PdpSharedPurchaseButton';
import { PdpSharedAuctionMessageContainer } from './PdpSharedAuctionMessageContainer';

// types
import { PdpSharedAuctionSecondChanceOffer_item$key as Item } from './__generated__/PdpSharedAuctionSecondChanceOffer_item.graphql';

// styles
import styles from './PdpSharedAuctionSecondChanceOffer.scss';

const itemFragment = graphql`
    fragment PdpSharedAuctionSecondChanceOffer_item on Item {
        ...PriceDisplay_item @arguments(userId: $userId, isTrade: $isTrade)
        ...PdpSharedPurchaseButton_item
    }
`;

type RelayVariables = {
    userId: string;
    itemId: string;
};

type ReduxStoreType = {
    relayVariables: {
        variables: RelayVariables;
    };
};

type Props = {
    item: Item;
    currency: string;
};

export const PdpSharedAuctionSecondChanceOffer: FC<Props> = ({ item: itemRef, currency }) => {
    const item = useFragment(itemFragment, itemRef);

    const { userId, itemId } = useSelector<ReduxStoreType, RelayVariables>(
        relay => relay?.relayVariables?.variables || {}
    );

    return (
        <div className={styles.container}>
            <PdpSharedAuctionMessageContainer
                isFullWidth
                text={
                    <FormattedMessage
                        id="PdpSharedAuctionSecondChanceOffer.secondChanceOffer"
                        defaultMessage="You have a limited-time offer from the seller."
                    />
                }
            />
            <div className={styles.price}>
                <PriceDisplay currency={currency} item={item} useSvgIcon sku={null} />
            </div>
            <div className={styles.purchase}>
                <PdpSharedPurchaseButton
                    item={item}
                    itemId={itemId}
                    userId={userId}
                    quantitySelected="1"
                />
            </div>
        </div>
    );
};
